import axiosInstance from '../../axiosInstance'

export const resendVerificationEmail = async (): Promise<void> => {
    await axiosInstance.post('email/verification-notification')
}